import PropTypes from 'prop-types';
import Base from './accordion';
import React from 'react';

/**
 * Accordion, or a wrapper that orchestrates multiple panels.
 *
 * @displayName Accordion (Web)
 * @class Accordion
 * @public
 */
export default class Accordion extends Base {
  /**
   * Renders the title element, if title is defined and not empty.
   *
   * @returns {React.DOM} renders accordion title
   * @private
   */
  title() {
    if (typeof this.props.title !== 'undefined' && this.props.title !== '') {
      return (
        <h1 className='text-center'>{ this.props.title }</h1>
      );
    }
    return null;
  }

  /**
   * Render the accordion.
   *
   * @returns {React.DOM} Wrapping div for the accordion
   * @private
   */
  render() {
    return (
      <div className={ this.props.className }>
        { this.title() }

        <div className='ux-accordion' aria-multiselectable='true' role='tablist' aria-live='polite'>
          { this.panels() }
        </div>
      </div>
    );
  }
}

/**
 * Property validation.
 *
 * @type {object}
 * @public
 */
Accordion.propTypes = {
  /** Which panel should be open by default. */
  open: PropTypes.number,
  /** The actual collapsible panels. */
  children: PropTypes.node.isRequired,
  /** The title for the accordion. */
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  /** Developer indicates start index */
  startTabIndex: PropTypes.number,
  /** Optional className */
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array
  ])
};



// WEBPACK FOOTER //
// ./node_modules/@ux/accordion/index.js